import { apiPost } from './apiConfig';

export interface GeocodeResolveResult {
  lat: number;
  lng: number;
  source: string;
  city: string;
  country: string;
}

export interface GeocodeBatchPlace {
  location: string;
  country: string;
  lat: number;
  lng: number;
  source: string;
  city: string;
  country_resolved: string;
}

/** One place: learned CSV first, then Nominatim; row appended on first Nominatim hit. */
export function geocodeResolve(
  location: string,
  country: string
): Promise<GeocodeResolveResult> {
  return apiPost('/geocode/resolve', {
    location: location || '',
    country: country || '',
  });
}

/** Up to 50 unique pairs; server spaces Nominatim ~1s. */
export function geocodeResolveBatch(places: { location: string; country: string }[]): Promise<{
  results: GeocodeBatchPlace[];
  errors: { location: string; country: string; detail: string }[];
}> {
  return apiPost('/geocode/resolve_batch', {
    places: places.map((p) => ({ location: p.location || '', country: p.country || '' })),
  });
}
